import { createNewRNGConfig } from "./index"
import type { RNGConfig } from "./RNGConfig.type"

export default function createEntityRngConfig(
  entityId: number
): RNGConfig {
  const rng = createNewRNGConfig()
  rng.seed = entityId
  rng.state = entityId
  return rng
}